import React from 'react';
import { Badge } from 'react-bootstrap';

export const LiveStockInfo = ({ liveStockInfo }: { liveStockInfo: any }) => {
  if (!liveStockInfo) return null;

  // Stok durumu kontrolü: Negatif mi?
  const isNegative = liveStockInfo.availableQuantity < 0;

  // Rozet Rengi: Pozitifse Yeşil, 0 veya Negatifse Kırmızı
  const availableColor = liveStockInfo.availableQuantity > 0 ? "success" : "danger";

  // Rezerve Stil: Rezerve varsa koyu sarı, yoksa silik gri
  const reservedStyle = liveStockInfo.reservedQuantity > 0 ? { color: "#d39e00", fontWeight: "bold" } : { color: "#999" };

  // Başlık Stili ve Metni (Dinamik)
  const headerText = isNegative ? "⚠️ STOK AŞIMI" : "📦 Stok Durumu";
  const headerColor = isNegative ? "#dc3545" : "#777"; // Negatifse Kırmızı, Değilse Gri
  const headerWeight = isNegative ? "bold" : "normal";

  // Kutu Stili (Negatifse kırmızımsı sınır)
  const borderStyle = isNegative ? "2px dashed #dc3545" : "2px dashed #ddd";
  const bgStyle = isNegative ? "#fff5f5" : "#fcfcfc"; // Negatifse çok açık kırmızı arka plan

  return (
    <div
         style={{
             padding: "4px 8px",
             border: borderStyle, // Dinamik sınır rengi
             borderRadius: "6px",
             backgroundColor: bgStyle, // Dinamik arka plan
             display: "flex",
             flexDirection: "column",
             justifyContent: "center",
             height: "auto",
             minWidth: "110px",
             maxWidth: "140px"
         }}>

      {/* BAŞLIK KISMI */}
      <div style={{
          fontSize: "0.7rem",
          color: headerColor,
          fontWeight: headerWeight,
          marginBottom: "3px",
          textAlign: "center",
          textTransform: "uppercase",
          letterSpacing: "0.5px"
        }}>
        {headerText}
      </div>

      {/* DEPO */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: "0.8rem", marginBottom: "1px" }}>
        <span>Depo:</span>
        <strong>{liveStockInfo.physicalQuantity}</strong>
      </div>

      {/* REZERVE */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: "0.8rem", marginBottom: "1px" }}>
        <span>Rezerve:</span>
        <span style={reservedStyle}>{liveStockInfo.reservedQuantity}</span>
      </div>

      <div style={{ borderTop: isNegative ? "1px solid #ffcccc" : "1px solid #e0e0e0", margin: "3px 0" }}></div>

      {/* SATILABİLİR */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span style={{ fontSize: "0.75rem", fontWeight: isNegative ? "bold" : "normal", color: isNegative ? "#dc3545" : "inherit" }}>
            Satılabilir:
        </span>
        <Badge bg={availableColor} style={{ fontSize: "0.85rem" }}>{liveStockInfo.availableQuantity}</Badge>
      </div>
    </div>
  );
};